import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { QualificationSection } from '../components/QualificationSection';
import { ProcessSection } from '../components/ProcessSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { FooterSection } from '../components/FooterSection';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-white font-body selection:bg-gold selection:text-navy-dark" data-id="element-263">
      <HeroSection data-id="element-264" />
      <ProblemSection data-id="element-265" />
      <SolutionSection data-id="element-266" />
      <QualificationSection data-id="element-267" />
      <ProcessSection data-id="element-268" />
      <FAQSection data-id="element-269" />
      <OfferSection data-id="element-270" />
      <FooterSection data-id="element-271" />
    </main>;
}